import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { CustomServerDataSource } from '@app/@theme/components/grid/data-source/server/custom-server.data-source';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import {
  BrowserStorageService,
  DE_LOCAL_KEYS,
} from '@app/@core/store/localStorage.service';
import { RouterService } from '@core/utils/router.service';

@Component({
    selector: 'ngx-grid',
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.scss'],
    standalone: false
})
export class GridComponent implements OnInit, OnDestroy {
  @Input() data: CustomServerDataSource;
  @Input() headers: any;
  @Input() settings: {};
  @Output() settingsChange = new EventEmitter<{}>();
  @Output() edit: EventEmitter<any> = new EventEmitter();
  @Output() delete: EventEmitter<any> = new EventEmitter();
  @Output() custom: EventEmitter<any> = new EventEmitter();
  @Output() rowSelect: EventEmitter<any> = new EventEmitter();
  @Output() onSearch: EventEmitter<any> = new EventEmitter();
  @Input() keyFilterCached: string;
  @Input() keySortCached: string;

  pageNums: number[] = [];
  pageSelected: number;
  column = {};
  source: CustomServerDataSource;
  routerSubscription = null;
  constructor(
    private routerService: RouterService,
    private router: Router,
    private localStorage: BrowserStorageService,
  ) {
    this.routerSubscription = this.router.events
      .pipe(filter((event: any) => event instanceof NavigationStart))
      .subscribe((event: any) => {
        this.cachedFilterAndSearchHandler(event);
      });
  }

  ngOnInit() {
    this.getData();
    this.setCachedFilter();
  }

  setCachedFilter() {
    if (this.keySortCached) {
      const sorts = this.localStorage.get(this.keySortCached, sessionStorage);
      sorts && this.data.setSort(sorts, false);
    }
    const currentUrl = this.routerService.getCurrentUrl();
    const previousUrl = this.routerService.getPreviousUrl();

    if (previousUrl === '/auth/login' || previousUrl.indexOf(currentUrl) === -1) {
      if (this.keyFilterCached) {
        this.localStorage.remove(this.keyFilterCached);
      }
      return;
    }

    if (previousUrl.indexOf(currentUrl) !== -1) {
      if (this.keyFilterCached) {
        const filters = this.localStorage.get(this.keyFilterCached);
        filters && this.data.setFilter(filters, false, false);
      }
    }

  }

  cachedFilterAndSearchHandler(event: any) {
    const nextUrl = event.url;
    const currentUrl = this.router.url;

    const gridFilters: [object] = this.data && this.data.getFilter().filters;
    const searchQuery: string = this.data && this.data.getSearchQuery().value;

    if (nextUrl.indexOf(currentUrl) !== -1) {
      if (this.keyFilterCached) {
        this.localStorage.set(
          this.keyFilterCached,
          gridFilters.map(response => {
            return { ...response, cached: true };
          }),
        );
      }
      this.localStorage.set(DE_LOCAL_KEYS.searchCacheKey, searchQuery);
    }
    if (this.keySortCached) {
      const gridSorts: [object] = this.data && this.data.getSort();
      this.localStorage.set(
        this.keySortCached,
        gridSorts.map(response => {
          return { ...response, cached: true };
        }), sessionStorage
      );
    }
  }

  getData() {
    this.settings = {
      mode: 'external',
      columns: this.headers,
      actions: {
        columnTitle: 'Actions',
        add: false,
        edit: true,
        delete: true,
        custom: null, // array of custom actions
        position: 'right', // left|right
      },
      edit: {
        editButtonContent: '<i class="fa-solid fa-pen"></i>',
      },
      delete: {
        deleteButtonContent: '<i class="fa-solid fa-trash"></i>',
      },
      pager: {
        display: true,
        perPage: 50,
        perPageSelect: [10, 20, 50, 100, 200],
        scrollToTop: true,
      },
      attr: {
        class: 'table-fixed',
      },
      ...this.settings
    };
    this.source = this.data;
    this.settingsChange.emit(this.settings);
  }

  onDelete(event) {
    this.delete.emit(event.data);
  }

  onEdit(event) {
    this.edit.emit(event.data);
  }

  onRowSelect(event) {
    this.rowSelect.emit(event.selected);
  }

  search(event) {
    this.onSearch.emit(event.data);
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }
}
